import AlertsForm from './alerts-form';

export default AlertsForm;
